import { convertirHoraMilitarA12h } from './Helper';

function escHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

export function formatearFechaCitaTooltip(fecha) {
    if (!fecha) return '';
    const s = String(fecha).slice(0, 10);
    const parts = s.split('-');
    if (parts.length !== 3) return s;
    const [y, m, d] = parts;
    return `${d}/${m}/${y}`;
}

export function obtenerNombrePacienteTooltip(cita) {
    const p = cita?.extendedProps ?? cita;

    const np = p.segundo_nombre
        ? `${p.primer_nombre || ''} ${p.segundo_nombre || ''}`.trim()
        : (p.primer_nombre || '');

    let ap = p.primer_apellido || '';
    const segundoApellido = p.segundo_apellido;
    if (segundoApellido && segundoApellido !== 'null' && String(segundoApellido).trim() !== '') {
        ap += ` ${segundoApellido}`;
    }

    const fromPaciente = `${np} ${ap}`.replace(/\s+/g, ' ').trim();
    if (fromPaciente) return fromPaciente;

    const nombreCompleto = `${p.primer_nombre || ''} ${p.segundo_nombre || ''} ${p.primer_apellido || ''} ${p.segundo_apellido || ''}`
        .replace(/\s+/g, ' ')
        .trim();
    if (nombreCompleto) return nombreCompleto;

    return (p.cita_paciente || '').trim();
}

export function buildCitaTooltipHtml(cita, options = {}) {
    const p = cita?.extendedProps ?? cita;
    const { fallbackAgenda = '', fallbackUnidad = '' } = options;

    if (p.bloqueo) {
        return `<p><strong>Bloqueo de agenda: </strong>${escHtml(p.descripcion_bloqueo)}</p>`;
    }

    const nombreMostrar = obtenerNombrePacienteTooltip(p);
    const documento = p.numero_documento || p.cita_documento || '';
    const estado = p.estado_cita || '';
    const agenda = p.nombre_agenda || fallbackAgenda || '';
    const unidad = p.nombre_unidad || fallbackUnidad || '';
    const convenio = p.nombre_convenio || '';
    const celular = p.celular || p.cita_celular || p.cita_telefono || '';
    const email = p.email || p.cita_email || '';
    const motivo = p.motivo_consulta || p.descripcion_cita || '';
    const fecha = formatearFechaCitaTooltip(p.fecha_cita);
    const horaRaw = p.hora_cita ? String(p.hora_cita).slice(0, 5) : '';
    const hora = convertirHoraMilitarA12h(horaRaw);

    return `<p><strong>Fecha: </strong>${escHtml(fecha)}</p>
            <p><strong>Hora: </strong>${escHtml(hora)}</p>
            <p><strong>Paciente: </strong>${escHtml(nombreMostrar)}</p>
            <p><strong>Documento: </strong>${escHtml(documento)}</p>
            <p><strong>Estado de la cita: </strong>${escHtml(estado)}</p>
            <p><strong>Agenda: </strong>${escHtml(agenda)}</p>
            <p><strong>Unidad de atención: </strong>${escHtml(unidad)}</p>
            <p><strong>Convenio: </strong>${escHtml(convenio)}</p>
            <p><strong>Celular: </strong>${escHtml(celular)}</p>
            <p><strong>e-mail: </strong>${escHtml(email)}</p>
            <p><strong>Motivo de consulta: </strong>${escHtml(motivo)}</p>`;
}

const TOOLTIP_MARGIN = 8;
const TOOLTIP_GAP = 14;
const TOOLTIP_WIDTH = 320;
const TOOLTIP_HEIGHT_ESTIMATE = 300;
const TOOLTIP_HEIGHT_BLOQUEO = 60;

export function calcularPosicionTooltipCita(anchorRect, options = {}) {
    if (!anchorRect) {
        return { top: `${TOOLTIP_MARGIN}px`, left: `${TOOLTIP_MARGIN}px` };
    }

    const estimatedHeight = options.esBloqueo
        ? TOOLTIP_HEIGHT_BLOQUEO
        : (options.estimatedHeight ?? TOOLTIP_HEIGHT_ESTIMATE);
    const tooltipWidth = Math.min(TOOLTIP_WIDTH, window.innerWidth * 0.92);

    let left = anchorRect.left;
    if (left + tooltipWidth + TOOLTIP_MARGIN > window.innerWidth) {
        left = window.innerWidth - tooltipWidth - TOOLTIP_MARGIN;
    }
    left = Math.max(TOOLTIP_MARGIN, left);

    const spaceBelow = window.innerHeight - anchorRect.bottom - TOOLTIP_GAP - TOOLTIP_MARGIN;
    const spaceAbove = anchorRect.top - TOOLTIP_GAP - TOOLTIP_MARGIN;

    let top;
    if (spaceBelow >= estimatedHeight || spaceBelow >= spaceAbove) {
        top = anchorRect.bottom + TOOLTIP_GAP;
    } else {
        top = anchorRect.top - estimatedHeight - TOOLTIP_GAP;
    }

    top = Math.max(TOOLTIP_MARGIN, top);
    if (top + estimatedHeight > window.innerHeight - TOOLTIP_MARGIN) {
        top = Math.max(TOOLTIP_MARGIN, window.innerHeight - estimatedHeight - TOOLTIP_MARGIN);
    }

    return { top: `${top}px`, left: `${left}px` };
}

export function ajustarPosicionTooltipMedido(anchorRect, tooltipEl, initialLeft) {
    if (!anchorRect || !tooltipEl) return null;

    const tw = tooltipEl.offsetWidth;
    const th = tooltipEl.offsetHeight;

    let left = typeof initialLeft === 'number' ? initialLeft : parseFloat(initialLeft) || TOOLTIP_MARGIN;
    const maxLeft = window.innerWidth - tw - TOOLTIP_MARGIN;
    left = Math.max(TOOLTIP_MARGIN, Math.min(left, maxLeft));

    const spaceBelow = window.innerHeight - anchorRect.bottom - TOOLTIP_GAP - TOOLTIP_MARGIN;
    const spaceAbove = anchorRect.top - TOOLTIP_GAP - TOOLTIP_MARGIN;

    let top;
    if (spaceBelow >= th || spaceBelow >= spaceAbove) {
        top = anchorRect.bottom + TOOLTIP_GAP;
    } else {
        top = anchorRect.top - th - TOOLTIP_GAP;
    }

    top = Math.max(TOOLTIP_MARGIN, top);
    if (top + th > window.innerHeight - TOOLTIP_MARGIN) {
        top = Math.max(TOOLTIP_MARGIN, window.innerHeight - th - TOOLTIP_MARGIN);
    }

    return { top: `${top}px`, left: `${left}px` };
}
